import { useMutation, gql } from "@apollo/client"
import moment from "moment"
import { v4 as uuid } from "uuid"
import { toId } from "../../utils"
import { ACTION_FIELDS } from "./useQueryActions"
import { makeOptimisticUserFromPrincipal } from "../makeOptimistic"

const CREATEACTION_MUTATION = gql`
  ${ACTION_FIELDS}
  mutation CreateAction(
    $title: String!
    $content: String!
    $job: ID
    $jobStep: ID
    $users: [ID!]
    $groups: [ID!]
    $uploads: [ID!]
  ) {
    createAction(
      title: $title
      content: $content
      job: $job
      jobStep: $jobStep
      users: $users
      groups: $groups
      uploads: $uploads
    ) {
      ...ActionFields
    }
  }
`

const makeCreateActionOptimisticResponse = ({ action: { locations, users, ...action }, principal }) => ({
  __typename: "Mutation",
  createAction: {
    __typename: "Action",
    ...action,
    id: uuid(),
    author: makeOptimisticUserFromPrincipal(principal),
    locations: locations.map((location) => ({
      __typename: "Location",
      id: toId(location),
      name: "...",
    })),
    users: users.map((user) => ({
      __typename: "User",
      id: toId(user),
      fullName: "...",
    })),
    hasSentConfirms: false,
    comments: [],
    confirmed: [],
    unconfirmed: [],
    createdAt: moment().format(),
    updatedAt: moment().format(),
  },
})

const useMutationCreateAction = () => useMutation(CREATEACTION_MUTATION)

export { useMutationCreateAction, makeCreateActionOptimisticResponse }
